<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-input v-model="query.title" @keyup.enter.native="resetList" placeholder="名称" />
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">确认查询</el-button>
          <el-button @click="emptySearch">清除条件</el-button>
          <el-button @click="handleCreate" type="primary">新增</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table
        ref="table"
        :data="list"
        v-loading="listLoading"
        element-loading-text="给我一点时间"
        stripe
      >
        <el-table-column align="left" type="index" width="60" label="#"></el-table-column>
        <el-table-column align="left" label="图片" width="220">
          <template slot-scope="scope">
            <img
              @click="$store.commit('SHOW_IMAGE_WALL', scope.row.photo)"
              :src="scope.row.photo | filterImage"
              class="banner"
            />
          </template>
        </el-table-column>
        <el-table-column align="left" prop="title" label="名称"></el-table-column>

        <el-table-column align="center" label="跳转方式">
          <template slot-scope="scope">
            {{ scope.row | filterContentType }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="广告位">
          <template slot-scope="scope">
            {{ scope.row.location === '0' ? '首页' : '充电页' }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="sort" label="排序"></el-table-column>
        <el-table-column align="center" label="上架">
          <template slot-scope="scope">
            <el-switch
              @change="handleEditStatus(scope.row)"
              :disabled="scope.row.statusDisabled"
              v-model="scope.row.status"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column align="left" label="表格操作" width="210">
          <template slot-scope="scope">
            <p>
              <el-button size="small" type="primary" @click="handleUpdate(scope.row.code)">
                编辑
              </el-button>
              <el-button size="small" type="danger" @click="handleDelete(scope.row.code)">
                删除
              </el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="query.current"
          :page-size="query.limit"
          layout="total, prev, pager, next"
          :total="listTotal"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getBanners, deleteBanner, changeBannerPutaway } from '@/api/banners'

export default {
  data() {
    return {
      // table
      list: [],
      listTotal: 0,
      listLoading: true,

      query: {
        title: '',
        pageIndex: 1,
        pageSize: 10
      }
    }
  },

  created() {
    this.resetList()
  },
  activated() {
    console.log('激活')

    this.resetList()
  },

  filters: {
    filterContentType(row) {
      if (row.type === '1') return '跳外链'
      if (row.type === '2') return '自定义编辑'
      if (row.type === '3') return '不跳转'
      if (row.type === '4') return '跳转页面'

      return null
    }
  },

  methods: {
    resetList() {
      this.query.pageIndex = 1
      this.getList()
    },
    // 清除查询
    emptySearch() {
      this.query.title = ''
      this.resetList()
    },

    getList() {
      this.listLoading = true
      getBanners(this.query).then((res) => {
        this.list = res.data.records.map((item) => {
          item.statusDisabled = false
          return item
        })
        this.listTotal = parseInt(res.data.pager.itemCount)
        this.listLoading = false
      })
    },

    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.getList()
    },

    handleCreate() {
      this.$router.push({ name: 'banners-create' })
    },

    handleUpdate(code) {
      this.$router.push({ name: 'banners-edit', params: { code } })
    },

    handleDelete(code) {
      this.$confirm('此操作将永久删除该轮播图, 是否继续?', '提示', {}).then(() => {
        deleteBanner({ code }).then(() => {
          this.$message.success('删除轮播图成功')
          this.getList()
        })
      })
    },

    filterCategory(val) {
      return this.category.find((item) => item.value === val).name
    },

    handleEditStatus(row) {
      row.statusDisabled = true
      console.log('row :>> ', row)
      const params = {
        ...row,
        status: row.status
      }
      changeBannerPutaway(params).then(() => {
        this.$message.success('修改状态成功')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  display: block;
  width: 160px;
  height: 80px;
  border-radius: 4px;
  object-fit: cover;
  cursor: pointer;
}
</style>
